import { cx } from '@onbeam/business-styled-system/css';
import { MainProps } from './Main.types';
import { vstack } from '@onbeam/business-styled-system/patterns';

export const Main = ({ className, children }: MainProps) => (
  <main
    className={cx(
      vstack({
        flex: '1',
        pb: { base: '20', md: '28' },
        px: { base: '6', md: '8' },
        w: 'full',
        mx: 'auto',
        maxW: '[74.625rem]',
      }),
      className,
    )}
  >
    {children}
  </main>
);
